import React, { createContext, useContext, useState, useEffect } from 'react';
import { palettes } from '../styles/themes';

const ThemeContext = createContext(undefined);

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeContext must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children, defaultPaletteId = 'zenrentflow-original' }) => {
  const [paletteId, setPaletteIdState] = useState(defaultPaletteId);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const savedPaletteId = localStorage.getItem('zenrentflow-theme-palette');
      if (savedPaletteId && palettes.find(p => p.id === savedPaletteId)) {
        setPaletteIdState(savedPaletteId);
      }
      setMounted(true);
    }
  }, []);

  const currentPalette = palettes.find(p => p.id === paletteId) || palettes[0];

  useEffect(() => {
    if (typeof window !== 'undefined' && mounted) {
      const root = document.documentElement;
      const colors = currentPalette.colors;

      root.style.setProperty('--color-primary', colors.primary);
      root.style.setProperty('--color-secondary', colors.secondary);
      root.style.setProperty('--color-accent', colors.accent);
      root.style.setProperty('--color-background', colors.background);
      root.style.setProperty('--color-surface', colors.surface);
      root.style.setProperty('--color-text-primary', colors.text.primary);
      root.style.setProperty('--color-text-secondary', colors.text.secondary);
      root.style.setProperty('--color-text-muted', colors.text.muted);
      root.style.setProperty('--color-border', colors.border);
      root.style.setProperty('--color-success', colors.success);
      root.style.setProperty('--color-error', colors.error);
      root.style.setProperty('--color-warning', colors.warning);
      root.style.setProperty('--color-info', colors.info);
    }
  }, [currentPalette, mounted]);

  const setPalette = (newPaletteId) => {
    if (palettes.find(p => p.id === newPaletteId)) {
      setPaletteIdState(newPaletteId);
      if (typeof window !== 'undefined') {
        localStorage.setItem('zenrentflow-theme-palette', newPaletteId);
      }
    }
  };

  const isActivePalette = (id) => paletteId === id;

  const value = {
    currentPalette,
    paletteId,
    setPalette,
    availablePalettes: palettes,
    isActivePalette,
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};






